import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=7a09c77c&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=7a09c77c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a09c77c",
  null
  
)

export default component.exports